import { useState } from 'react';
import { useLocation } from 'wouter';
import {
  Settings as SettingsIcon,
  User,
  Bell,
  Shield,
  HelpCircle,
  FileText,
  LogOut,
  ChevronRight,
  Moon,
  Sun
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import BottomNav from '../components/BottomNav';

export default function Settings() {
  const [, setLocation] = useLocation();
  const { user, logout } = useAuth();
  const [darkMode, setDarkMode] = useState(true);
  const [notifications, setNotifications] = useState(true);

  const handleLogout = async () => {
    if (confirm('确定要退出登录吗?')) {
      await logout();
      setLocation('/login');
    }
  };

  const menuItems = [
    {
      icon: User,
      label: '个人资料',
      onClick: () => setLocation('/profile'),
      showArrow: true
    },
    {
      icon: Bell,
      label: '通知设置',
      onClick: () => setNotifications(!notifications),
      toggle: true,
      value: notifications
    },
    {
      icon: darkMode ? Moon : Sun,
      label: '深色模式',
      onClick: () => setDarkMode(!darkMode),
      toggle: true,
      value: darkMode
    },
    {
      icon: Shield,
      label: '隐私与安全',
      onClick: () => alert('功能开发中'),
      showArrow: true
    },
    {
      icon: HelpCircle,
      label: '帮助与反馈',
      onClick: () => alert('功能开发中'),
      showArrow: true
    },
    {
      icon: FileText,
      label: '服务条款',
      onClick: () => alert('功能开发中'),
      showArrow: true
    }
  ];

  return (
    <div className="min-h-screen bg-[#1a2e3e] pb-24">
      {/* 头部 */}
      <div className="p-6">
        <h1 className="text-3xl font-bold text-white mb-6">设置</h1>

        {/* 用户信息卡片 */}
        <div className="glass rounded-2xl p-5 mb-6">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#22a9d9] to-[#6c5ce7] flex items-center justify-center">
              <span className="text-white text-2xl font-bold">
                {user?.name?.charAt(0) || 'U'}
              </span>
            </div>
            <div className="flex-1">
              <h3 className="text-white font-medium text-lg mb-1">
                {user?.name || '用户'}
              </h3>
              <p className="text-white/60 text-sm">{user?.email}</p>
            </div>
            <button
              onClick={() => setLocation('/profile')}
              className="text-white/60 hover:text-white transition-colors"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

      {/* 设置菜单 */}
      <div className="px-6 space-y-3">
        {menuItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <button
              key={index}
              onClick={item.onClick}
              className="w-full glass rounded-2xl p-4 flex items-center gap-4 hover:bg-white/10 transition-colors"
            >
              <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center">
                <Icon className="w-5 h-5 text-[#22a9d9]" />
              </div>
              <span className="flex-1 text-left text-white font-medium">
                {item.label}
              </span>
              {item.toggle ? (
                <div
                  className={`w-12 h-6 rounded-full transition-colors ${
                    item.value ? 'bg-[#22a9d9]' : 'bg-white/20'
                  }`}
                >
                  <div
                    className={`w-5 h-5 rounded-full bg-white mt-0.5 transition-transform ${
                      item.value ? 'ml-6' : 'ml-0.5'
                    }`}
                  />
                </div>
              ) : item.showArrow ? (
                <ChevronRight className="w-5 h-5 text-white/40" />
              ) : null}
            </button>
          );
        })}

        {/* 退出登录 */}
        <button
          onClick={handleLogout}
          className="w-full glass rounded-2xl p-4 flex items-center gap-4 hover:bg-red-500/10 transition-colors border border-red-500/20"
        >
          <div className="w-10 h-10 rounded-xl bg-red-500/10 flex items-center justify-center">
            <LogOut className="w-5 h-5 text-red-400" />
          </div>
          <span className="flex-1 text-left text-red-400 font-medium">
            退出登录
          </span>
        </button>
      </div>

      {/* 版本信息 */}
      <div className="text-center mt-8 text-white/40 text-sm">
        书流 v1.0.0
      </div>

      <BottomNav />
    </div>
  );
}
